import { render, staticRenderFns } from "./WhoWeAre.vue?vue&type=template&id=2623f01a&scoped=true&"
var script = {}
import style0 from "./WhoWeAre.vue?vue&type=style&index=0&id=2623f01a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2623f01a",
  null
  
)

export default component.exports